import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver, ComponentRef } from '@angular/core';

import {
  keys as _keys,
  each as _each
} from 'lodash';

import { NotifierService } from './notifier.service';
import { AlertComponent } from './alert.component';

/**
 * Root view for alerts
 */
@Component({
  selector: 't-alerts',
  templateUrl: './alerts.component.html',
  entryComponents: [
    AlertComponent
  ],
})
export class AlertsComponent implements OnInit {

  alert: ComponentRef<{}> = null;

  @ViewChild(
    'alertsPlaceholder',
    {
      read: ViewContainerRef
    }
  )
  alertsPlaceholder: ViewContainerRef;

  constructor(
    private notifierService: NotifierService,
    private resolver: ComponentFactoryResolver) 
  { }

  ngOnInit(): void {

    this.notifierService.currentAlert.subscribe((data) => {

      // Open a alert
      if (data) {
      
        // destroy the current alert if any
        if(this.alert) {
          this.alert.destroy();
        }

        // Create the alert
        let factory = this.resolver.resolveComponentFactory(AlertComponent);
        let dialog = this.alertsPlaceholder.createComponent(factory);

        // Init the dialog
        _each(_keys(data.props), (prop) => {
          dialog.instance[prop] = data.props[prop];
        });

        this.alert = dialog;

        setTimeout(() => {
          (<AlertComponent>this.alert.instance).state = 'open';
        }, 0);
      }

      // Close the alert
      else {
        (<AlertComponent>this.alert.instance).state = 'closed';

        setTimeout(() => {
          this.alert.destroy();
          this.alertsPlaceholder.clear();
        }, 300);
      }

    });
  }
}
